export default __webpack_public_path__ + "static/media/sign-in-welcome-2.a827edb7.jpg";